import { Checkbox, FormControlLabel, Grid2 as Grid, Paper, TextField } from "@mui/material"
import { useEffect, useRef, useState } from "react"
import moment from "moment"
// import "moment-timezone"

function Slot({ data, day, handleChange }) {
  const endTime = useRef(null)
  const startTime = useRef(null)
  const daySchedule = data?.schedule?.[day]
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    // Check if daySchedule exists and has data
    const hasSchedule = Boolean(
      daySchedule &&
      Object.keys(daySchedule).length > 0 &&
      daySchedule.startTime &&
      daySchedule.endTime
    )

    setChecked(hasSchedule)
    // eslint-disable-next-line
  }, [data, day])

  return (
    <Paper variant="contentListing" sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={{ xs: 12, sm: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={checked}
                onChange={(e) => {
                  if (e.target.checked) {
                    handleChange({ [day]: { startTime: "09:00", endTime: "17:00", } })
                  } else {
                    handleChange({ [day]: undefined })
                  }
                  setChecked(!checked)
                }}
              />
            }
            slotProps={{ typography: { sx: { textTransform: "capitalize" } } }}
            label={day}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            type="time"
            size="small"
            label="Start Time"
            disabled={!checked}
            inputRef={startTime}
            key={day + "-" + checked}
            defaultValue={
              data?.schedule?.[day]?.startTime ?
                moment
                  .tz(
                    data?.schedule?.[day]?.startTime,
                    "HH:mm",
                    data?.timeZone
                  )
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format("HH:mm")
                : "09:00"
            }
            onChange={() => {
              handleChange({
                [day]: {
                  endTime: endTime.current.value,
                  startTime: startTime.current.value,
                }
              })
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            fullWidth
            type="time"
            size="small"
            inputRef={endTime}
            label="End Time"
            disabled={!checked}
            key={day + "-" + checked}
            defaultValue={
              data?.schedule?.[day]?.endTime ?
                // moment.parseZone(data?.schedule?.[day]?.endTime).format("HH:mm")
                moment
                  .tz(
                    data?.schedule?.[day]?.endTime,
                    "HH:mm",
                    data?.timeZone
                  )
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                  .format("HH:mm")
                : "17:00"
            }
            onChange={(e) => {
              handleChange({
                [day]: {
                  endTime: endTime.current.value,
                  startTime: startTime.current.value,
                }
              })
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export default Slot